import React from 'react'
import _ from 'lodash'
import withReduxModal from '../../modules/redux-modal/redux/withReduxModal'
import { getImageFile } from '../../modules/portal-remote/portalImageService'
import {
  IMAGE_EDIT_MODAL,
  PORTAL_IMAGE_STORE_MODAL,
} from '../../constants/modalType'
import GooglePickerImage from '../../modules/google-picker/GooglePickerImage'
import GoogleDriveContainer from '../../modules/google-drive/GoogleDriveContainer'

// const LoginModalContent = ({ params, onRequestClose }) => (
//   <div>
//     Modal
//     {JSON.stringify(params)}
//     <button onClick={() => onRequestClose({ hello1: 'test1', ...params })}>
//       Close
//     </button>
//   </div>
// )
// const LoginModal = withBulmaModalLayout(LoginModalContent)

// const AnotherModalContent = ({ params, onRequestClose }) => (
//   <div>
//     AnotherModal
//     {JSON.stringify(params)}
//     <button onClick={() => onRequestClose({ hello2: 'test2', ...params })}>
//       Close
//     </button>
//   </div>
// )

// const AnotherModal = withBulmaModalLayout(AnotherModalContent)

class PlaygroundPage extends React.Component {
  constructor(props) {
    super(props)
    this.showEditModal = _.debounce(this.showEditModal, 500)
  }

  state = {}

  showEditModal = async imageID => {
    const imageFile = await getImageFile(imageID)

    this.props.modalActions.showModal(IMAGE_EDIT_MODAL, {
      imageFile,
      imageAspectRatio: 4 / 3,
    })
  }

  showModal = async () => {
    const storeImages = [
      { mainImageId: '5bd88ddb2c354403f1bbe962' },
      { mainImageId: '5bd88df42c354403f1bbe963' },
    ]

    this.props.modalActions.showModal(PORTAL_IMAGE_STORE_MODAL, {
      storeImages,
    })
  }

  render() {
    return (
      <div>
        <button onClick={this.showModal}>show modal</button>
        <GooglePickerImage />
        <GoogleDriveContainer />
        PlaygroundPage
        {/* <ModalBuilder
          component={AnotherModal}
          onDismiss={params => console.log('props from another modal', params)}
        >
          {({ showModal: showAnotherModal }) => (
            <ModalBuilder
              component={LoginModal}
              onDismiss={params => showAnotherModal(params)}
            >
              {({ showModal }) => (
                <button onClick={() => showModal({ title: 'Login' })}>
                  ShowModal
                </button>
              )}
            </ModalBuilder>
          )}
        </ModalBuilder> */}
      </div>
    )
  }
}

export default withReduxModal(PlaygroundPage)



// WEBPACK FOOTER //
// ./src/components/pages/PlaygroundPage.js